import gql from "graphql-tag"

export const queryUsers = gql`
  query usersInfo($email: String, $vat: String) {
    companies(where: { vat_code: { _eq: $vat } }, limit: 1, order_by: { update_timestamp: desc_nulls_last }) {
      sfid
      business_name
      tax_code
      profiles(
        where: { login_email: { _eq: $email }, is_active: { _eq: true } }
        limit: 1
        order_by: { update_timestamp: desc_nulls_last }
      ) {
        sfid
        contact {
          sfid
          mobile
          first_name
          last_name
          tax_code
        }
      }
    }
  }
`
